import { faKey } from '@fortawesome/free-solid-svg-icons';
import { faLockKeyhole } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { MenuItem } from '@zinc/ui';

import { useDialogContext } from 'bz-stores/hooks/dialog';
import AuthStore from 'bz-stores/lib/auth-store';

import withDisplayName from 'bz-utilities/hoc/display-name';

import React, { useEffect, useMemo, useState } from 'react';

import { MfaSetupDialog } from './MfaSetupDialog';

interface IProps {}

export enum MfaState {
  Initial,
  Loading,
  Changed,
  Failed,
  SetupPassKey,
  Setup,
  SetupPassKeyComplete,
  PasskeyFailed,
  None
}

const MFA = React.memo(
  withDisplayName((props: IProps) => {
    const [, openDialog, closeDialog] = useDialogContext();

    const [mfaState, setMfaState] = useState(MfaState.None);

    const changeMfa = useMemo(() => mfaState != MfaState.None, [mfaState]);

    useEffect(() => {
      if (changeMfa) openDialog();
    }, [changeMfa, openDialog]);

    return (
      <>
        <MenuItem
          className="w-full"
          key="passkey"
          onClick={() => setMfaState(MfaState.SetupPassKey)}
          size="small"
          icon={<FontAwesomeIcon icon={faKey} />}
        >
          Add Passkey
        </MenuItem>
        {AuthStore.user.twoFactorSetup ? (
          <MenuItem
            className="w-full"
            key="reset-mfa"
            onClick={() => setMfaState(MfaState.Initial)}
            size="small"
            icon={<FontAwesomeIcon icon={faLockKeyhole} />}
          >
            Reset Multi Factor Auth
          </MenuItem>
        ) : (
          <MenuItem
            className="w-full"
            onClick={() => setMfaState(MfaState.Setup)}
            size="small"
            key="setup-mfa"
            icon={<FontAwesomeIcon icon={faLockKeyhole} />}
          >
            Setup Multi Factor Auth
          </MenuItem>
        )}
        <MfaSetupDialog
          onChange={setMfaState}
          mode={mfaState}
          open={changeMfa}
          onRequestClose={() => {
            closeDialog();
            setMfaState(MfaState.None);
          }}
        />
      </>
    );
  }, 'MFA')
);

export default MFA;
